export enum FormKeys {
    Phone = 'phone',
    Name = 'name',
    Address = 'address',
}

export enum FormPhoneKeys {
    Flag = 'flag',
    DialCode = 'dialCode',
    Number = 'number',
}

export enum FormAddressKeys {
    Address = 'address',
    Coordinates = 'coordinates',
    Zone = 'zone',
    isValid = 'isValid',
}
